import { Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { NoContentComponent } from './no-content/no-content.component';
import { UasPortalComponent } from './portal/containers/uas-portal.component';

export const APP_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: AppComponent
  },
  {
    path: 'uas/portal',
    component: UasPortalComponent,
  },
  {
    path: '**',
    component: NoContentComponent,
  }
];
